import React, { useEffect } from "react";
// import { NodeState } from "../../store/slices/node.slice";
// import { useSelector } from "react-redux";

const CellEncoderControlPanel: React.FC = () => {
    // Get memories from the react state
    // const nodesDataState: NodeState = useSelector((state: any) => state.nodeData);

    useEffect(() => {
        // console.log(nodesDataState.cells);
    }, []);

    return (
        <div id="cell-encoder-control-panel" className="cell-encoder-control panel-contents">
            <div className="no-access-container">
                <div className="">
                    <h1 className="title">CONFIDENTIAL</h1>
                    <p>You do not have access to this Nucleoli</p>
                </div>

                <div className="">
                    <p>
                        This Cellular Encoder design is proprietary and only <br />
                        available to the Neo AI Digital Brain Surgeons
                    </p>
                </div>
            </div>
        </div>
    );
};

export default CellEncoderControlPanel;
